<template>
    <div class="content-with-info-box">
      <div class="col">
        <template v-if="hasQuotesByLanguage">
          <div v-for="(quote, index) in getQuotesByLanguage" v-bind:key="index">
            <div class="testimonial-container" v-if="index < 2">
              <div class="testimonial">
                <div class="col-photo">
                  <img :src="quote[0].content.image" :alt="quote[0].quotePositionAndName" />
                </div>
                <div class="col-text">
                  <div class="testimonial-text">
                    “{{ quote[0].quote }}”
                  </div>
                  <div class="testimonial-from-whom">
                    {{ quote[0].quotePositionAndName }}
                  </div>
                </div>
              </div>
              <hr style="margin: 20px;" />
            </div>
          </div>
        </template>

        <div class="movie-box">
          <template v-if="isYoutubeVideo(movie)">
            <iframe :src="movie" class="lazyload" title="(Youtube) Video" rel="preconnect" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </template>

          <template v-if="!isYoutubeVideo(movie)">
            <video class="lazyload" style="width: 100%; border: 1px solid #000; border-radius: 10px;" controls="controls" title="Video" rel="preconnect">
              <source :src="movie" type="video/mp4" />
              Your browser does not support the video tag
            </video>
          </template>
        </div>
      </div>
      <div class="col">
        <template v-for="item in infoboxes">
            <infobox :icon="item.icon" :styleType="item.color" :title="item.title" :content="item.content" :callToAction="item.button_text" :url="item.url" :key="item.title" />
        </template>
      </div>
    </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faInfo } from '@fortawesome/free-solid-svg-icons/faInfo'
import { faPlaneDeparture } from '@fortawesome/free-solid-svg-icons/faPlaneDeparture'
import { faThumbsUp } from '@fortawesome/free-solid-svg-icons/faThumbsUp'
import { faGraduationCap } from '@fortawesome/free-solid-svg-icons/faGraduationCap'
import { mapGetters } from 'vuex'

library.add(faInfo)
library.add(faPlaneDeparture)
library.add(faThumbsUp)
library.add(faGraduationCap)

export default {
  name: 'Col2WithInfoBox',
  data () {
    return {
      infoIcon: faInfo,
      departIcon: faPlaneDeparture,
      thumbIcon: faThumbsUp
    }
  },
  computed: {
    ...mapGetters('website', [
      'getQuotesByLanguage',
      'hasQuotesByLanguage'
    ])
  },
  props: {
    content: {
      type: String,
      required: false,
      default: 'Content goes here'
    },
    infoboxes: {
      type: Array,
      required: false
    },
    movie: {
      type: String,
      required: false
    }
  },
  methods: {
    getIcon (iconString) {
      const spl = iconString.split('-')
      const prefix = spl[0]
      const icon = spl.slice(1).join('-')
      return [prefix, icon]
    },
    isYoutubeVideo (url) {
      if (url === null) {
        return false
      }

      if (typeof url === 'undefined') {
        return false
      }

      return url.includes('youtube.com')
    }
  }
}
</script>

<style>
.btn {
  height: 1rem;
  display: inline-block;
  padding: 10px 15px 22px 15px;
}

a.btn {
  text-decoration: none;
}

.movie-box {
  position: relative;
  bottom: 0px;
  left: 0px;
  width: 100%;
  height: auto;
  min-height: 40%;
}

.call-to-action-btn {
  font-size: 15px;
  background-color: #ce5e31;
  color: #fff;
  border-radius: 20px;
  width: auto;
}

.content-with-info-box {
  display: flex;
  flex: column;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.content-with-info-box .col .testimonial-container {
  text-align: left;
  vertical-align: center;
  color: #262b55;
}

.content-with-info-box .col .testimonial-container .col-photo {
  text-align: left;
  width: 25%;
  margin-right: 20px;
  display: inline-block;
  vertical-align: top;
}

.content-with-info-box .col .testimonial-container .col-photo img {
  width: 100%;
  height: auto;
  border-radius: 10%;
}

.content-with-info-box .col .testimonial-container .col-text {
  text-align: left;
  width: 70%;
  display: inline-block;
}

.content-with-info-box .col .testimonial-container .testimonial .testimonial-text {
  font-size: 20px;
  font-style: italic;
  font-family: "Roboto", sans-serif
}

.content-with-info-box .col .testimonial-container .testimonial .testimonial-from-whom {
  font-size: 14px;
  font-family: "Roboto", sans-serif
}

.content-with-info-box .col:nth-child(1) {
  justify-content: space-around;
  order: 1;
  flex-grow: 1;
  flex-wrap: wrap;
  margin-left: 15px;
}

.content-with-info-box .col:nth-child(2) {
  justify-content: initial;
  order: 2;
  flex-grow: 2;
  background-color: #d0e3f3;
  border-top-left-radius: 80px;
  height: auto;
  flex-wrap: wrap;
  margin-right: 0px;
}

.col ul {
  list-style: none;
  list-style-position:inside;
  margin-left: 0px;
  padding-left: 0px;
  color: #ce5e31;
  display: table;
}

.col li {
  color: #000;
  font-size: 15px;
  display: table-row;
}

.col li:before {
  content: "\2022";  /* Add content: \2022 is the CSS Code/unicode for a bullet */
  color: #ce5e31; /* Change the color */
  font-weight: bold; /* If you want it to be bold */
  display: inline-block; /* Needed to add space between the bullet and the text */
  padding-right: 8px;
  font-size:50px;
  vertical-align:top;
  line-height:20px;
  display: table-cell;
}

/* Small devices (landscape phones, 576px and up) */
@media (max-width: 576px) {
  .content-with-info-box .col:nth-child(1) {
    flex-basis: 100%;
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 20px;
    margin-bottom: 20px;
    order: 2
  }

  .content-with-info-box .col:nth-child(2) {
    margin-top: 20px;
    order: 1
  }

  .content-with-info-box .col .testimonial-container .col-photo {
    width: 20%;
  }

  .content-with-info-box .col .testimonial-container .col-text {
    width: 70%;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {
  .content-with-info-box .col:nth-child(1) {
    flex-basis: 100%;
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .content-with-info-box .col .testimonial-container .col-photo {
    width: 20%;
  }

  .content-with-info-box .col .testimonial-container .col-text {
    width: 70%;
  }
}

/* Medium devices (tablets, 768px and up) The navbar toggle appears at this breakpoint */
@media (min-width: 768px) {
  .content-with-info-box .col:nth-child(1) {
    flex-basis: 100%;
    margin-left: 35px;
    margin-right: 35px;
  }

  .content-with-info-box .col:nth-child(2) {
    margin-top: 20px;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .content-with-info-box .col:nth-child(1) {
    order: 1;
    flex-basis: 375px;
    margin-left: 35px;
    margin-right: 35px;
  }

  .content-with-info-box .col:nth-child(2) {
    order: 2;
    flex-basis: 58%;
    margin-right: 0px;
    margin-top: 0px;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .content-with-info-box .col:nth-child(1) {
    flex-basis: 375px;
    margin-left: 35px;
    margin-right: 35px;
  }

  .content-with-info-box .col:nth-child(2) {
    flex-basis: 52%;
  }
}
</style>
